import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"
import { OrderSearchBySerialNbrController as OrderSearchBySerialNbrController } from "./order-search-by-serial-nbr.controller"

//#region Asset Imports

import * as TEMPLATE from './order-search-by-serial-nbr.tpl.html'
import './order-search-by-serial-nbr.scss'

//#endregion

export const COMPONENT_NAME: string = 'orderSearchBySerialNbr'

export class OrderSearchBySerialNbrComponent {

    controller = [USER_SESSION_SERVICE_NAME, OrderSearchBySerialNbrController]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}